<template>
  <div class="px-0 pb-0 card-body">
    <div v-if="loading && filteredData.length === 0" class="text-center py-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-2">Loading CLOUDE EPON data...</p>
    </div>
    <div class="table-responsive" v-else-if="filteredData.length > 0">
      <div class="card mb-4">
        <div class="card-body px-0 pt-0 pb-2 invoice">
          <div class="table-responsive p-0">
            <table class="table align-items-center mb-0">
              <thead>
                <tr>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    Port
                  </th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    MAC Address
                  </th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    ONU ID
                  </th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    ONU Name
                  </th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    Software Version
                  </th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    Last Up Time
                  </th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    Last Down Time
                  </th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(onu, index) in filteredData" :key="index">
                  <td class="align-middle text-center text-sm">
                    {{ onu.PortName || onu.PonId }}
                  </td>
                  <td class="align-middle text-center text-sm">
                    {{ formatMacAddress(onu.Mac) }}
                  </td>
                  <td class="align-middle text-center text-sm">
                    {{ onu.OnuId }}
                  </td>
                  <td class="align-middle text-center text-sm">
                    {{ onu.OnuName || 'N/A' }}
                  </td>
                  <td class="align-middle text-center text-sm">
                    <span v-if="loadingPPPOE">
                      <span class="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
                    </span>
                    <span v-else>
                      {{ onu.SwVersion || 'N/A' }}
                    </span>
                  </td>
                  <td class="align-middle text-center text-sm">
                    {{ formatDateTime(onu.LastUpTime) }}
                  </td>
                  <td class="align-middle text-center text-sm">
                    {{ formatDateTime(onu.LastDownTime) }}
                  </td>
                  <td class="text-center">
                    <soft-badge
                      class="p-1 rounded-1 text-white cursor-pointer text-sm"
                      :class="getStatusBadgeClass(onu.RunningState)"
                      variant="gradient"
                      size="sm"
                    >
                      {{ formatStatus(onu.RunningState) }}
                    </soft-badge>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <Skalaton />
    </div>
  </div>
</template>

<script>
import Skalaton from "@/components/Skalaton.vue";

export default {
  name: "CdataV12EponTable",
  components: {
    Skalaton
  },
  props: {
    loading: Boolean,
    loadingPPPOE: Boolean,
    filteredData: {
      type: Array,
      default: () => []
    },
    sortKey: String,
    sortOrder: String
  },
  methods: {
    getStatusBadgeClass(runningState) {
      // RunningState: 0 = Down, 1 = Up (based on typical OLT status codes)
      if (runningState === 1) return 'bg-success';
      if (runningState === 0) return 'bg-danger';
      return 'bg-warning';
    },
    
    formatStatus(runningState) {
      switch(runningState) {
        case 1: return 'UP';
        case 0: return 'DOWN';
        default: return 'UNKNOWN';
      }
    },
    
    formatDateTime(dateTime) {
      if (!dateTime) return 'N/A';
      
      try {
        // Parse the date string and format it
        const date = new Date(dateTime);
        if (isNaN(date.getTime())) return 'N/A';
        
        return date.toLocaleString();
      } catch (error) {
        return 'N/A';
      }
    },
    
    formatMacAddress(mac) {
      if (!mac) return 'N/A';
      
      // Remove any existing separators and convert to lowercase
      const cleanMac = mac.replace(/[^a-f0-9]/gi, '').toLowerCase();
      
      // Format as xx:xx:xx:xx:xx:xx
      return cleanMac.match(/.{1,2}/g)?.join(':') || mac;
    },

    // Additional helper method for last seen calculation
    calculateLastSeen(lastUpTime) {
      if (!lastUpTime) return 'N/A';
      
      try {
        const lastUp = new Date(lastUpTime);
        const now = new Date();
        const diffSeconds = Math.floor((now - lastUp) / 1000);
        
        if (diffSeconds < 60) return `${diffSeconds} seconds ago`;
        if (diffSeconds < 3600) return `${Math.floor(diffSeconds / 60)} minutes ago`;
        if (diffSeconds < 86400) return `${Math.floor(diffSeconds / 3600)} hours ago`;
        return `${Math.floor(diffSeconds / 86400)} days ago`;
      } catch (error) {
        return 'N/A';
      }
    }
  }
};
</script>

<style scoped>
.table th {
  padding: 12px 24px !important;
}

.sort-icon {
  margin-left: 5px;
}

.asc::after {
  content: "▲";
}

.desc::after {
  content: "▼";
}

.bg-danger {
  background-color: #f56565 !important;
}

.bg-success {
  background-color: #48bb78 !important;
}

.bg-warning {
  background-color: #ed8936 !important;
}
</style>